/**
 * Optional PDP line item property "Gift Message": toggle, 200 char cap, sticky form sync,
 * and submit-time omission when unchecked or empty (disabled fields excluded from FormData).
 */
(function () {
  var GIFT_STICKY_SEL = ".ajluxe-gift-message--sticky";
  var GIFT_MAIN_ROOT = "[data-ajluxe-gift-main]";

  function getMainRoot() {
    return document.querySelector(GIFT_MAIN_ROOT);
  }

  function getStickyField() {
    return document.querySelector(
      ".sticky-cart-single " + GIFT_STICKY_SEL
    );
  }

  function syncToSticky() {
    var main = getMainRoot();
    var sticky = getStickyField();
    if (!sticky) return;
    if (!main) {
      sticky.disabled = true;
      sticky.value = "";
      return;
    }
    var cb = main.querySelector(".ajluxe-gift-message__toggle");
    var ta = main.querySelector(".ajluxe-gift-message__textarea");
    if (!cb || !ta) {
      sticky.disabled = true;
      sticky.value = "";
      return;
    }
    var trimmed = ta.value.trim().slice(0, 200);
    if (cb.checked && trimmed) {
      sticky.disabled = false;
      sticky.value = trimmed;
    } else {
      sticky.disabled = true;
      sticky.value = "";
    }
  }

  /* Write through the existing text node instead of replacing it: `textContent =`
     is a childList mutation, and Clarity's replay player applies the insert but
     not the remove, so the node replays holding every value it has ever held.
     nodeValue edits replay as one value. Full rationale and the canonical copy
     live in assets/ajluxe-cart-boost.js. */
  function setText(node, value) {
    if (!node) return;
    var first = node.firstChild;
    if (first && first.nodeType === 3 && !first.nextSibling) {
      if (first.nodeValue !== value) first.nodeValue = value;
      return;
    }
    node.textContent = value;
  }

  function updateCount(main) {
    var ta = main.querySelector(".ajluxe-gift-message__textarea");
    var num = main.querySelector(".ajluxe-gift-message__count-num");
    if (!ta || !num) return;
    var len = ta.value.length;
    setText(num, String(len));
  }

  function applySubmitGuard(form) {
    var main = form.querySelector(GIFT_MAIN_ROOT);
    if (!main) return;
    var cb = main.querySelector(".ajluxe-gift-message__toggle");
    var ta = main.querySelector(".ajluxe-gift-message__textarea");
    if (!cb || !ta) return;
    if (!cb.checked) {
      ta.disabled = true;
    } else {
      var trimmed = ta.value.trim().slice(0, 200);
      if (trimmed) {
        ta.disabled = false;
        ta.value = trimmed;
      } else {
        ta.disabled = true;
      }
    }
  }

  function initMain(main) {
    if (!main || main.getAttribute("data-ajluxe-gift-initialized") === "1")
      return;
    main.setAttribute("data-ajluxe-gift-initialized", "1");

    var cb = main.querySelector(".ajluxe-gift-message__toggle");
    var ta = main.querySelector(".ajluxe-gift-message__textarea");
    var wrap = main.querySelector(".ajluxe-gift-message__field-wrap");
    if (!cb || !ta || !wrap) return;

    function onToggle() {
      if (cb.checked) {
        wrap.hidden = false;
        ta.disabled = false;
      } else {
        wrap.hidden = true;
        ta.disabled = true;
      }
      updateCount(main);
      syncToSticky();
    }

    function onInput() {
      if (ta.value.length > 200) {
        ta.value = ta.value.slice(0, 200);
      }
      updateCount(main);
      syncToSticky();
    }

    cb.addEventListener("change", onToggle);
    ta.addEventListener("input", onInput);
    onToggle();
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.getAttribute("data-product-form")) return;
    if (form.tagName !== "FORM") return;

    var isSticky = !!form.closest(".sticky-cart-single");

    if (isSticky) {
      syncToSticky();
    } else {
      applySubmitGuard(form);
    }
  }, true);

  function runInit() {
    var main = getMainRoot();
    if (main) {
      initMain(main);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }
})();
